import React from 'react';
import { PrismicLink } from '@prismicio/react';
import { Post } from '@/shared/types/blog';
import './index.less';
import Image from 'next/image';

const BlogCard = ({ post }: { post: Post }) => {
  return (
    <PrismicLink document={post} className="blog-card-container">
      <div className="blog-card-image">
        <Image
          src={post?.data?.image?.url}
          alt="blog image"
          sizes="(max-width: 831.99px) calc(100vw - 32px), 524px"
          width={524}
          height={274}
        />
      </div>
      <div className="blog-card-info">
        <div className="header">
          <span>{post?.data?.category}</span>
          <span className="dot"></span>
          {post?.data?.reading_time && <span>{post?.data?.reading_time} MIN</span>}
        </div>
        <div className="title">{post?.data?.title}</div>
        <div className="desc">{post?.data?.seo_description}</div>
        <div className="author-info">
          {post?.data?.author_avator?.url && (
            <Image src={post?.data?.author_avator?.url} className="avator" alt="author avator" width={36} height={36} />
          )}
          <div className="author">
            <p>{post?.data?.author}</p>
            <p>{post?.data?.author_position}</p>
          </div>
        </div>
      </div>
    </PrismicLink>
  );
};

export default BlogCard;
